import { observer } from "mobx-react";
import { useSnackbarContext } from "~/SnackbarProvider_v2";
import { TextField } from "~/components/TextField";

type PhoneProps = {
  phone: string;
  onChange: (params?: any) => void;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  border?: boolean;
};

const Phone = ({
  phone,
  onChange,
  className,
  placeholder,
  disabled,
  border = false,
}: PhoneProps) => {
  const snackbar = useSnackbarContext();

  const onChangePhone = (value: string, event: Event) => {
    event.preventDefault();

    if (!/^[0-9-]*$/.test(value)) {
      snackbar.alert("숫자만 입력하세요.");
      return;
    }

    if (value.length > 13) {
      snackbar.alert("전화번호는 최대 11자리입니다.");
      return;
    }

    const numberTemp = (value || "")
      .replace(/[^0-9]/g, "")
      .replace(
        /(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})/,
        "$1-$2-$3"
      )
      .replace("--", "-");
    onChange(numberTemp);
  };

  return (
    <div className={`phone ${className}`}>
      <TextField
        value={(phone || "")
          .replace(/[^0-9]/g, "")
          .replace(
            /(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})/,
            "$1-$2-$3"
          )
          .replace("--", "-")}
        onChange={onChangePhone}
        placeholder={placeholder}
        disabled={disabled}
        hasBorder={border}
      />
    </div>
  );
};

export default observer(Phone);
